import { system } from 'styled-system';

import type { ThemeFontWeight } from '@rover/kibble/styles';
import { WEB_FALLBACK_FONT_FAMILIES } from '@rover/kibble/styles';

export type FontWeightProps = {
  fontWeight?: ThemeFontWeight;
};
type FontFamily = 'Averta-Regular' | 'Averta-Semibold' | 'Averta-Extrabold';

const getFontFamilyForWeight = (weight: ThemeFontWeight): FontFamily => {
  switch (weight) {
    case 'extrabold':
      return 'Averta-Extrabold';

    case 'semibold':
      return 'Averta-Semibold';

    case 'regular':
    default:
      return 'Averta-Regular';
  }
};

const config = system({
  fontWeight: {
    property: 'fontFamily',
    scale: 'fontWeight',
    transform: (propValue) => {
      const fontFamily = getFontFamilyForWeight(propValue);
      // if not on react native, append fallback fonts
      if (!process.env.JS_ENV_NATIVE) {
        return `${fontFamily}, ${WEB_FALLBACK_FONT_FAMILIES}`;
      }
      return fontFamily;
    },
  },
});
export default config;



// WEBPACK FOOTER //
// ../kibble/styles/styled-system/fontWeight.ts